import {interfaceClass} from './interfaceClass';
import {simpleClass} from './simpleClass';

export function classPens() {
  return {
    interfaceClass,
    simpleClass,
  };
}
